__turbopack_context__.v({
  "emptyState": "component-module__0tqNIW__emptyState",
  "hero": "component-module__0tqNIW__hero",
  "heroExpanded": "component-module__0tqNIW__heroExpanded",
  "heroLabel": "component-module__0tqNIW__heroLabel",
  "heroText": "component-module__0tqNIW__heroText",
  "heroTextOnly": "component-module__0tqNIW__heroTextOnly",
  "heroValue": "component-module__0tqNIW__heroValue",
  "ring": "component-module__0tqNIW__ring",
  "root": "component-module__0tqNIW__root",
  "statGrid": "component-module__0tqNIW__statGrid",
  "statIcon": "component-module__0tqNIW__statIcon",
  "statLabel": "component-module__0tqNIW__statLabel",
  "statTile": "component-module__0tqNIW__statTile",
  "statValue": "component-module__0tqNIW__statValue",
});
